import React from "react";
import { Link } from "react-router-dom";

export const Navigation = (props) => {
  return (
    <nav
      id="menu"
      className="navbar navbar-expand-lg navbar-light bg-light navbar-main"
    >
      <div className="container">
        <a className="navbar-brand page-scroll" href="#page-top">
          <span className="brand-wrapper">
            <img src="img/logo/unn-logo.png" alt="LMCS Logo" className="logo-img" />
            <span className="brand-text">LMCS</span>
          </span>
        </a>
        <button
          type="button"
          className="navbar-toggler collapsed"
          data-toggle="collapse"
          data-target="#example-navbar-collapse-1"
        >
          <span className="navbar-toggler-icon">
            <i className="fas fa-bars"></i>
          </span>
        </button>
        <div
          className="collapse navbar-collapse"
          id="example-navbar-collapse-1"
        >
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <a href="#features" className="nav-link page-scroll">
                Features
              </a>
            </li>
            <li className="nav-item">
              <a href="#about" className="nav-link page-scroll">
                About
              </a>
            </li>
            <li className="nav-item">
              <a href="#services" className="nav-link page-scroll">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a href="#non-member-services" className="nav-link page-scroll">
                Public Services
              </a>
            </li>
            <li className="nav-item">
              <a href="#portfolio" className="nav-link page-scroll">
                Gallery
              </a>
            </li>
            <li className="nav-item">
              <a href="#mission-vision" className="nav-link page-scroll">
                Mission & Vision
              </a>
            </li>
            <li className="nav-item">
              <a href="#faqs" className="nav-link page-scroll">
                FAQs
              </a>
            </li>
            <li className="nav-item">
              <a href="#team" className="nav-link page-scroll">
                Team
              </a>
            </li>
            <li className="nav-item">
              <a href="#contact" className="nav-link page-scroll">
                Contact
              </a>
            </li>
          </ul>
          <div className="nav-buttons">
            <a href="https://dashboard.lmcsnigltd.org.ng" className="nav-btn login-btn">
              LOGIN
            </a>
            <Link to="/signup" className="nav-btn join-btn">
              JOIN
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
